import { User } from "@supabase/supabase-js";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function isDevEnvironment() {
  return process.env.NODE_ENV === "development" || window.location.search.includes('kinetic_debug=1');
}


export function getName(user: User) {
  return user.user_metadata.display_name || user.user_metadata.displayName || user.email;
}



